import MediaPlayer from "../../../lib/media_player";
import React from "react";
import { ModalContentWrapper } from "./accept_advertisement_modal_helpers";
import { respondToCampaignOffer } from "../../../../actions/campaigns";
import { handleRespPromise } from "../../../../lib/http";

export const AcceptPreRecordedContent = props => {
  const { campaignItem } = props;

  const mediaFileUUID = campaignItem.mediaFileUUID;

  return (
    <>
      <div className="margin-bottom-small">
        Review the pre-recorded ad below, and click <b>Accept & Run</b> to accept this promotion.
        This Pre-Recorded Ad will automatically run on the available audio blocks on your show’s
        episodes.
      </div>

      <MediaPlayer mediaFileUUID={mediaFileUUID} />
    </>
  );
};
export const reviewPreRecordConfig = props => ({
  title: "Review & Accept Advertisement",
  submitText: "Accept & Run",
  onSubmit: () => {
    return props
      .dispatch(respondToCampaignOffer(props.campaignItem.uuid, "accepted"))
      .then(handleRespPromise);
  },
  Content: (
    <ModalContentWrapper>
      <AcceptPreRecordedContent {...props} />
    </ModalContentWrapper>
  ),
});
